import React from 'react'
import { Col, Row } from 'antd'

const DispatchTerms = () => {
  return (
    <>
      <Row className='_mb-48 term-info' align='middle' justify='space-between'>
        <Col></Col>
        <Col>
          <span className='_uppercase'>Last updated:</span>{' '}
          <strong className='_ml-12'>12 Jan 2026</strong>
        </Col>
      </Row>
      <Row className='terms general-settings' justify='center'>
        <Col span={12}>
          <div>
            <div>
              <p>
                These Delivery Terms and Conditions ("Terms") govern the use of
                the Dispatch service ("Dispatch") operated by Slerp Ltd
                ("Slerp", "we", "us", "our"). Dispatch enables merchants and
                partners ("Partner", "you") to access a network of third-party
                courier providers for last-mile delivery within the United
                Kingdom.
              </p>
              <p>
                By using Dispatch, you agree to these Terms, which supplement
                Slerp's General Terms of Service.
              </p>
            </div>
            <ol>
              <li>
                <span>Service Overview</span>
                <ol type='a'>
                  <li>
                    Dispatch is a technology and operations service that
                    integrates with multiple third-party courier fleets
                    ("Couriers") to facilitate on-demand and scheduled
                    deliveries.
                  </li>
                  <li>
                    Slerp does not itself provide delivery services. All
                    deliveries are performed by independent Couriers.
                  </li>
                  <li>
                    Slerp maintains commercial relationships with Couriers and
                    is responsible for billing and payment to them. You will
                    only be invoiced by Slerp.
                  </li>
                </ol>
              </li>
              <li>
                <span>Courier Terms</span>
                <ol type='a'>
                  <li>
                    Each Courier engaged through Dispatch operates subject to
                    its own terms and conditions, which include (without
                    limitation):
                    <ul>
                      <li>
                        <a
                          href='https://www.uber.com/legal/br/document/?name=uber-direct---general-terms&country=great-britain&lang=en-gb'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Uber Direct Terms
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://merchants.deliveroo.com/legal/terms'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Deliveroo Terms
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://stuart.com/terms/'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Stuart
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.addisonlee.com/wp-content/uploads/2025/12/Addison-Lee-Business-Terms-and-Conditions.pdf'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Addison Lee
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.pedivan.com/terms-and-conditions'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Pedivan
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://uk.gophr.com/terms-and-conditions/customer'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Gophr
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://www.pedalme.co.uk/terms'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          PedalMe
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://autofleet.io/terms-and-conditions'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Autofleet
                        </a>
                      </li>
                      <li>
                        <a
                          href='https://onfleet.com/terms'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          Onfleet
                        </a>
                      </li>
                    </ul>
                  </li>
                  <li>
                    By using Dispatch, you agree to comply with the operational
                    requirements and restrictions of the applicable Courier(s).
                  </li>
                  <li>
                    In the event of a conflict between these Terms and a
                    Courier's terms, these Terms govern your relationship with
                    Slerp. You remain responsible for compliance with Courier
                    operational requirements.
                  </li>
                </ol>
              </li>
              <li>
                <span>Partner Responsibilities</span>
                <ol type='a'>
                  <li>
                    <strong>Pickup Information.</strong> You are responsible for
                    ensuring that all pickup information provided to Slerp
                    (including site location, address, operating hours, and
                    readiness time for collection) is accurate and kept up to
                    date.
                  </li>
                  <li>
                    <strong>End-Customer Information.</strong> Delivery details
                    relating to end-customers (including name, phone number,
                    delivery address, delivery instructions, and basket
                    contents) are provided directly by the end-customer at the
                    point of order. Slerp and Couriers rely on this information
                    as submitted and accept no responsibility for inaccuracies,
                    omissions, or errors. Slerp has no liability for failed,
                    delayed, or misdelivered orders resulting from incorrect
                    end-customer information.
                  </li>
                  <li>
                    <strong>Packaging:</strong> You are responsible for ensuring
                    that all items:
                    <ul>
                      <li>
                        Are securely packaged to prevent leakage, spillage,
                        breakage, or tampering;
                      </li>
                      <li>
                        Are appropriately labelled, including allergen and
                        nutritional information where required;
                      </li>
                      <li>
                        Are at a suitable temperature and condition for
                        delivery;
                      </li>
                      <li>
                        Comply with all food safety, alcohol, and product
                        labelling laws.
                      </li>
                    </ul>
                    Couriers may refuse collection of inadequately packaged or
                    non-compliant items.
                  </li>
                  <li>
                    <strong>Regulatory Compliance.</strong> You are solely
                    responsible for ensuring compliance with all applicable
                    laws, including food hygiene, alcohol licensing and
                    age-verification, and restricted items.
                  </li>
                  <li>
                    <strong>Prohibited Items.</strong> You may not request
                    delivery of prohibited or restricted items, including
                    (without limitation) weapons, drugs, tobacco, hazardous
                    materials, living animals, high-value securities, fragile
                    items, and any items prohibited by the relevant Courier.
                  </li>
                </ol>
              </li>
              <li>
                <span>Delivery Costs and Fees</span>
                <ol type='a'>
                  <li>
                    Standard delivery charges are published at:{' '}
                    <a
                      href='https://support.slerp.com/knowledge/delivery-costs'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      https://support.slerp.com/knowledge/delivery-costs
                    </a>
                    .
                  </li>
                  <li>
                    Additional fees may apply, including (without limitation):
                    Courier cancellation fees (where an order is cancelled after
                    rider assignment); Waiting time fees; Rebound or
                    return-to-store fees; Vehicle upgrade surcharges; Time
                    surcharges (i.e. weekend surcharges); Other courier-specific
                    operational fees.
                  </li>
                  <li>
                    Such fees vary by Courier and will be recharged to you by
                    Slerp as incurred.
                  </li>
                  <li>
                    Delivery fees and applicable surcharges will be invoiced by
                    Slerp periodically in accordance with your agreement with
                    Slerp.
                  </li>
                  <li>
                    <strong>Waiting Time Fees.</strong> Couriers may apply
                    waiting time fees where a courier arrives at the pickup
                    location and is required to wait beyond a courier-defined
                    grace period before the order is ready for collection
                    ("Waiting Time Fees"). Grace periods, charging thresholds,
                    and per-minute rates are set by the relevant Courier and may
                    differ between Couriers. Waiting Time Fees are calculated
                    based on timestamps and data recorded by the Courier.
                  </li>
                  <li>
                    <strong>
                      Responsibility and Pass-Through of Waiting Time Fees.
                    </strong>{' '}
                    You acknowledge that Waiting Time Fees typically arise where
                    orders are not ready for collection within the applicable
                    grace period. You are responsible for ensuring that orders
                    are prepared and available for handover at the pickup time
                    communicated via the Slerp platform. Any Waiting Time Fees
                    incurred will be recharged to you by Slerp at cost. Slerp
                    does not mark up Waiting Time Fees. Waiting Time Fees may be
                    charged regardless of whether the delivery is completed,
                    cancelled, or rebounded.
                  </li>
                </ol>
              </li>
              <li>
                <span>Service Availability and Operations</span>
                <ol type='a'>
                  <li>
                    Slerp will maintain integrations with Courier networks and
                    provide live operational support to facilitate courier
                    assignment.
                  </li>
                  <li>
                    Slerp does not guarantee the availability of Couriers at any
                    given time, nor the acceptance of any specific delivery
                    request.
                  </li>
                  <li>
                    Delivery times are estimates only and are not guaranteed.
                  </li>
                  <li>
                    <strong>Fleet Selection.</strong> Dispatch determines the
                    allocation and prioritisation of Couriers at its discretion.
                    Selection may take into account vehicle suitability, order
                    details, pickup and delivery locations, cost, courier
                    availability, and service-level performance.
                  </li>
                </ol>
              </li>
              <li>
                <span>Refund Policy</span>
                <ol type='a'>
                  <li>
                    <strong>General Position:</strong> Delivery services are
                    performed by independent Couriers. The Couriers integrated
                    with Dispatch may subcontract delivery services to
                    independent delivery providers. Each Courier (and any
                    subcontractor engaged by them) applies its own refund and
                    claims policies, which differ. Some Couriers do not provide
                    refunds in any circumstances. Others may refund delivery
                    fees only, or in limited cases part of the basket value,
                    subject to caps, exclusions, and conditions.
                  </li>
                  <li>
                    <strong>No Guarantee of Refunds:</strong> Slerp does not
                    guarantee any refund. Refunds are strictly limited to
                    amounts successfully recovered from the relevant Courier
                    under its applicable refund or adjustment policy.
                  </li>
                  <li>
                    <strong>When Refunds May Be Available:</strong> Slerp may,
                    at its discretion, submit a refund claim where there is
                    clear evidence that a delivery failure was caused by Courier
                    fault.
                  </li>
                  <li>
                    <strong>When Refunds Will Not Apply:</strong> Refunds are
                    not available where issues arise from:
                    <ul>
                      <li>Missing, incorrect, or incomplete items</li>
                      <li>Partner preparation or packaging issues</li>
                      <li>Food quality complaints</li>
                      <li>Customer-entered delivery information</li>
                      <li>Any scenario excluded by the Courie's policy</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Limitation of Liability:</strong> Slerp's liability
                    in respect of delivery failures is strictly limited to
                    amounts actually recovered from the Courier. In many cases,
                    no refund will be recoverable.
                  </li>
                </ol>
              </li>
              <li>
                <span>Liability</span>
                <ol type='a'>
                  <li>
                    Slerp is not liable for the acts, omissions, delays, or
                    performance of Couriers.
                  </li>
                  <li>
                    Couriers are independent contractors and are not employees,
                    agents, or subcontractors of Slerp.
                  </li>
                  <li>
                    To the maximum extent permitted by law, Slerp excludes all
                    liability for losses arising from Courier performance, order
                    data errors, packaging failures, or customer-entered
                    information.
                  </li>
                </ol>
              </li>
              <li>
                <span>Data and Privacy</span>
                <ol type='a'>
                  <li>
                    Slerp shares order, pickup, and delivery data with Couriers
                    as necessary to fulfil deliveries.
                  </li>
                  <li>
                    Slerp and Couriers act as independent data controllers in
                    respect of customer data.
                  </li>
                  <li>
                    You must ensure that end-customers are informed that their
                    data will be shared with Couriers for delivery purposes.
                  </li>
                  <li>
                    Delivery and rider data must not be retained for longer than
                    two (2) years.
                  </li>
                </ol>
              </li>
              <li>
                <span>Termination and Suspension</span>
                <ol type='a'>
                  <li>
                    Slerp may suspend or terminate access to Dispatch where you
                    breach these Terms, misuse the service, or fail to pay
                    invoices when due.
                  </li>
                  <li>
                    Termination of Dispatch does not affect any other agreement
                    between you and Slerp.
                  </li>
                </ol>
              </li>
              <li>
                <span>General</span>
                <ol type='a'>
                  <li>
                    These Terms are governed by the laws of England and Wales.
                  </li>
                  <li>
                    The courts of England and Wales have exclusive jurisdiction
                    over any dispute arising from these Terms.
                  </li>
                </ol>
              </li>
            </ol>
          </div>
        </Col>
      </Row>
    </>
  )
}

export default DispatchTerms
